import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import { Outlet } from 'react-router-dom';

export default function MarketingLayout() {  
  return (
    <>
      <Topbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}